import React from 'react';

const PUBLIC_BUCKET =
    'https://codepro-public.s3.ir-thr-at1.arvanstorage.ir';

const PRIVATE_BUCKET =
    'https://codepro-private.s3.ir-thr-at1.arvanstorage.ir';


const ResponsiveImage = ({
                             alt,
                             src,
                             desktop,
                             tablet,
                             mobile,
                             className,
                             isPublic = true
                         }) => {

    const bucket = isPublic
        ? PUBLIC_BUCKET
        : PRIVATE_BUCKET;


    const getImageUrl = (image) => {

        if (!image) return '';

        // Already an absolute URL
        if (
            image.startsWith('http://') ||
            image.startsWith('https://')
        ) {
            return image;
        }

        // Remove leading slash so we don't get //
        const path = image.replace(/^\/+/, '');

        return `${bucket}/${path}`;
    };


    return (
        <picture className={className}>

            {desktop && (
                <source
                    type="image/webp"
                    media="(min-width: 1024px)"
                    srcSet={getImageUrl(desktop)}
                />
            )}

            {tablet && (
                <source
                    type="image/webp"
                    media="(min-width: 600px)"
                    srcSet={getImageUrl(tablet)}
                />
            )}

            {mobile && (
                <source
                    type="image/webp"
                    media="(max-width: 599px)"
                    srcSet={getImageUrl(mobile)}
                />
            )}

            <img
                src={getImageUrl(src)}
                alt={alt || ''}
                loading="lazy"
                className={className}
            />

        </picture>
    );
};


export default ResponsiveImage;